// Tiny self-contained seed script. Inlined as a string (not a .sql file)
// so it bundles cleanly without any Vite asset config. Total payload is
// well under 5 KB and the loaded database fits in well under 50 KB —
// instant on first open, no network round-trip.
//
// Schema mirrors a generic HR-style dataset that's enough to demo joins,
// aggregates, and CTEs without overwhelming the schema sidebar.

export const SAMPLE_DB_NAME = 'sample_company';

export const SAMPLE_SEED_SQL = `
DROP TABLE IF EXISTS assignments;
DROP TABLE IF EXISTS projects;
DROP TABLE IF EXISTS employees;
DROP TABLE IF EXISTS departments;

CREATE TABLE departments (
  id INTEGER PRIMARY KEY,
  name TEXT NOT NULL,
  budget INTEGER NOT NULL
);

CREATE TABLE employees (
  id INTEGER PRIMARY KEY,
  name TEXT NOT NULL,
  email TEXT UNIQUE NOT NULL,
  department_id INTEGER NOT NULL REFERENCES departments(id),
  hired_on TEXT NOT NULL,
  salary INTEGER NOT NULL,
  manager_id INTEGER REFERENCES employees(id)
);

CREATE TABLE projects (
  id INTEGER PRIMARY KEY,
  name TEXT NOT NULL,
  status TEXT NOT NULL CHECK (status IN ('planned','active','done','cancelled')),
  started_on TEXT,
  finished_on TEXT
);

CREATE TABLE assignments (
  employee_id INTEGER NOT NULL REFERENCES employees(id),
  project_id INTEGER NOT NULL REFERENCES projects(id),
  role TEXT NOT NULL,
  hours_per_week INTEGER NOT NULL,
  PRIMARY KEY (employee_id, project_id)
);

INSERT INTO departments (id, name, budget) VALUES
  (1, 'Engineering', 2400000),
  (2, 'Design', 750000),
  (3, 'Operations', 900000),
  (4, 'Sales', 1500000);

INSERT INTO employees (id, name, email, department_id, hired_on, salary, manager_id) VALUES
  (1, 'Ada Lovelace', 'ada@example.com', 1, '2019-03-12', 175000, NULL),
  (2, 'Linus Torvalds', 'linus@example.com', 1, '2020-06-01', 165000, 1),
  (3, 'Grace Hopper', 'grace@example.com', 1, '2018-11-23', 180000, NULL),
  (4, 'Margaret Hamilton', 'margaret@example.com', 1, '2021-04-19', 145000, 3),
  (5, 'Donald Knuth', 'don@example.com', 1, '2022-09-08', 155000, 1),
  (6, 'Dieter Rams', 'dieter@example.com', 2, '2017-02-14', 140000, NULL),
  (7, 'Jony Ive', 'jony@example.com', 2, '2019-08-30', 135000, 6),
  (8, 'Susan Kare', 'susan@example.com', 2, '2020-12-01', 125000, 6),
  (9, 'Edsger Dijkstra', 'edsger@example.com', 3, '2018-05-22', 130000, NULL),
  (10, 'Tim Berners-Lee', 'tim@example.com', 3, '2021-10-10', 120000, 9),
  (11, 'Steve Wozniak', 'woz@example.com', 4, '2016-01-15', 160000, NULL),
  (12, 'Mary Allen Wilkes', 'mary@example.com', 4, '2022-03-04', 110000, 11);

INSERT INTO projects (id, name, status, started_on, finished_on) VALUES
  (1, 'Migrate to Postgres', 'active', '2025-09-01', NULL),
  (2, 'Customer portal redesign', 'active', '2025-10-15', NULL),
  (3, 'Holiday campaign', 'planned', NULL, NULL),
  (4, 'Inventory automation', 'done', '2025-01-10', '2025-08-29'),
  (5, 'Brand refresh', 'cancelled', '2025-02-01', '2025-04-12'),
  (6, 'Internal tooling', 'active', '2025-07-22', NULL);

INSERT INTO assignments (employee_id, project_id, role, hours_per_week) VALUES
  (1, 1, 'Tech Lead', 25),
  (2, 1, 'Engineer', 30),
  (4, 1, 'Engineer', 20),
  (3, 4, 'Tech Lead', 15),
  (5, 6, 'Engineer', 35),
  (1, 6, 'Reviewer', 5),
  (6, 2, 'Design Lead', 20),
  (7, 2, 'Designer', 30),
  (8, 3, 'Designer', 25),
  (9, 6, 'Ops Lead', 10),
  (10, 4, 'Ops', 15),
  (11, 3, 'Sales Lead', 20),
  (12, 3, 'Sales', 30);
`;

export const SAMPLE_INFO = {
  name: SAMPLE_DB_NAME,
  description:
    'A tiny HR/projects schema with 4 tables, ~30 rows. Try a JOIN across employees + departments + assignments + projects.',
  starterQuery: `-- See who's working on what.
SELECT e.name AS employee,
       d.name AS dept,
       p.name AS project,
       a.role,
       a.hours_per_week AS hrs
FROM employees e
JOIN departments d ON d.id = e.department_id
JOIN assignments a ON a.employee_id = e.id
JOIN projects p ON p.id = a.project_id
WHERE p.status = 'active'
ORDER BY d.name, e.name;`,
};
